import { FatDealCatalogPageOpenOpportunitiesQuery, Security_Status } from '@/__generated__/graphql';
import { MinusScoreIcon } from '@/assets/icons/minusScore';
import Button from '@/components/basicComponents/button';
import { Tooltip } from '@/components/basicComponents/tooltip';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import NoResults from '@/components/table/noResults';
import RedirectTitleCell from '@/components/table/redirectTitleCell';
import { getUTCDate } from '@/shared/utils/date';
import guid from '@/shared/utils/guid';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { TableRowCell, TableRowWrapper, TextCell } from '../../table/styles';
import { opportunitiesTableColumns } from '../constants';
import { TypeWindow } from '../types';

interface OpenOpportunitiesTableBodyProps {
  openOpportunitiesData: FatDealCatalogPageOpenOpportunitiesQuery['OpenOpportunities']['data'];
  openPage: (id: string, type: TypeWindow) => void;
}

const TableBody = ({ openOpportunitiesData, openPage }: OpenOpportunitiesTableBodyProps) => {
  if (!openOpportunitiesData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {openOpportunitiesData.map((row) => (
        <TableRowWrapper key={row.id}>
          <TableRowCell width={opportunitiesTableColumns[0].width}>
            <RedirectTitleCell id="actionCurioText" onClick={() => openPage(row.id, 'opportunityDetails')}>
              {row.name}
            </RedirectTitleCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[1].width}>
            <TextCell>{row?.subAssetClass ? `${row?.assetClass?.name} - ${row?.subAssetClass?.name}` : row?.assetClass?.name}</TextCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[2].width}>
            <TextCell>
              {row?.subAssetClasses?.length > 1 ? (
                <Tooltip title={row.subAssetClasses.toString().replace(/,/g, ', ')}>Multiple ({row.subAssetClasses.length})</Tooltip>
              ) : (
                row?.subAssetClasses && row?.subAssetClasses[0]
              )}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[3].width}>
            <TextCell>{row.type}</TextCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[4].width}>
            <TextCell>{row.investorDocsDue && getUTCDate(new Date(row.investorDocsDue))}</TextCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[5].width}>
            <TextCell>
              {row.aggregateCommitment ? (
                <FormattingTooltip zIndex={1000} key={guid()}>
                  {row.aggregateCommitment}
                </FormattingTooltip>
              ) : (
                <></>
              )}
            </TextCell>
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[6].width}>
            {row.securityStatus === Security_Status.Open && (
              <ButtonWrap id="infoWrap">
                <Button size="sm" onClick={() => openPage(row.id, 'opportunityDetails')}>
                  Allocate
                </Button>
              </ButtonWrap>
            )}
          </TableRowCell>
          <TableRowCell width={opportunitiesTableColumns[7].width}>
            {row.securityStatus !== Security_Status.Open && (
              <TooltipWrapper>
                <Tooltip title="Closed">
                  <MinusScoreIcon width={29} height={29} fill={themeVar('font.disabled')} />
                </Tooltip>
              </TooltipWrapper>
            )}
          </TableRowCell>
        </TableRowWrapper>
      ))}
    </>
  );
};

export default TableBody;

const ButtonWrap = styled.div`
  opacity: 0;
`;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  top: 3px;
`;
